<script setup>
import { EllipsisVerticalIcon, SettingsIcon } from "lucide-vue-next";
import { computed, inject, ref } from "vue";

import ActionModal from "@/Components/Modal/ActionModal.vue";

import { Menu, MenuButton, MenuItems } from "@headlessui/vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  menuItemsClass: {
    type: String,
    required: false
  },
  static: {
    type: Boolean,
    required: false,
    default: false
  }
});

const twMerge = inject("twMerge");
const showModal = ref(false);
const isMobile = computed(() => window.innerWidth < 640); // sm breakpoint
const computedMenuItemsClass = computed(() =>
  twMerge("absolute right-auto z-20 mt-1 divide-y overflow-hidden rounded-lg border bg-white", props.menuItemsClass)
);

const openMenu = () => {
  if (isMobile.value) {
    showModal.value = true;
  }
};

const closeModal = () => {
  showModal.value = false;
};
</script>

<template>
  <div>
    <!-- Desktop version -->
    <Menu v-slot="slotProps" ref="menuRef" :disabled="disabled" as="div" class="right-0 hidden sm:inline-block">
      <span class="cursor-pointer">
        <MenuButton v-if="$slots.button">
          <slot name="button" v-bind="slotProps" />
        </MenuButton>
        <MenuButton v-else class="w-8 rounded-full p-0 text-600 hover:text-700">
          <EllipsisVerticalIcon class="hidden h-5 w-5 sm:inline" />
          <SettingsIcon class="h-5 w-5 sm:hidden" />
        </MenuButton>
      </span>
      <!--end::button-->

      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems v-slot="slotProps2" :static="static" :class="computedMenuItemsClass">
          <slot v-bind="slotProps2" />
        </MenuItems>
        <!--end::menu-items-->
      </transition>
      <!--end::transition-->
    </Menu>

    <!-- Mobile version -->
    <div class="block sm:hidden">
      <div class="flex-center">
        <div v-if="$slots.button" @click="openMenu">
          <slot name="button" />
        </div>
        <button v-else class="rounded-full p-0 text-600 hover:text-700" :disabled="disabled" @click="openMenu">
          <EllipsisVerticalIcon class="hidden h-5 w-5 sm:inline" />
          <SettingsIcon class="h-4 w-4 sm:hidden" />
        </button>
      </div>

      <ActionModal :show="showModal" @close="closeModal">
        <slot :close="closeModal" />
      </ActionModal>
    </div>
  </div>
</template>
